export default "__VITE_ASSET__tEW9eWjm__"